'use strict';

angular.module('theme').component('notice', {
	templateUrl: 'component/notice.html',
	bindings: {
		show: '=',
		dismissible: '<',
		onDismiss: '&'
	},
	transclude: true,
	controller: function() {
		var self = this;

		this.dismiss = function() {
			if (!self.dismissible) return false;

			self.show = false;
			self.onDismiss();
		};
	}
});
